export default __webpack_public_path__ + "static/media/Tarifas_EN.059971ec.png";